/** Women.NYC advisor interest form (SurveyMonkey). Override via REACT_APP_MENTOR_SURVEY_URL. */
export const NYC_MENTOR_SURVEY_URL =
  process.env.REACT_APP_MENTOR_SURVEY_URL ||
  "https://www.surveymonkey.com/r/WNYCadvisorinterest";

export const isNycRegistrationMode = () => process.env.REACT_APP_NYC_MODE === "true";
